/** System-wide archived flag (`_archived`). */
export function isItemArchived(item: unknown): boolean {
    if (!item || typeof item !== "object") {
        return false
    }
    return (item as Record<string, unknown>)._archived === true
}

export type ArchivedListMode = "all" | "no" | "only"

/** Apply archive/restore to in-memory table rows for immediate UI feedback. */
export function applyArchivedStateToTableRows(
    rows: unknown[],
    uids: string[],
    archived: boolean,
    listMode: ArchivedListMode
): unknown[] {
    const uidSet = new Set(uids.filter((uid) => typeof uid === "string" && uid.length > 0))
    if (uidSet.size === 0 || !Array.isArray(rows)) {
        return rows
    }

    if (archived) {
        if (listMode === "no") {
            return rows.filter((item) => {
                const uid =
                    item && typeof item === "object" ? (item as { uid?: string }).uid : undefined
                return !uid || !uidSet.has(uid)
            })
        }
        return rows.map((item) => {
            const uid =
                item && typeof item === "object" ? (item as { uid?: string }).uid : undefined
            if (!uid || !uidSet.has(uid)) {
                return item
            }
            return { ...(item as Record<string, unknown>), _archived: true }
        })
    }

    if (listMode === "only") {
        return rows.filter((item) => {
            const uid =
                item && typeof item === "object" ? (item as { uid?: string }).uid : undefined
            return !uid || !uidSet.has(uid)
        })
    }

    return rows.map((item) => {
        const uid =
            item && typeof item === "object" ? (item as { uid?: string }).uid : undefined
        if (!uid || !uidSet.has(uid)) {
            return item
        }
        return { ...(item as Record<string, unknown>), _archived: false }
    })
}
